
<template>
	<div class="do-it-yorself">
		<v-e24-nav-bar/>
		<headerInterior />
		<contentTwoColumns />
		<greenBar/>
		<bigImage />
		<threeColumns />
		<v-e24-footer :build="build"/>
	</div>
</template>

<script>
import headerInterior from '@/components/doit/HeaderInterior'
import contentTwoColumns from '@/components/doit/contentTwoColumns'
import greenBar from '@/components/doit/greenBarOverlay'
import bigImage from '@/components/doit/contentBigImage'
import threeColumns from '@/components/doit/threeColumnsText'
import readBuild from '../util/readBuild'

export default {
	name: 'DoItYourself',
	components: {
		headerInterior,
		contentTwoColumns,
		greenBar,
		bigImage,
		threeColumns
	},
	data: function () {
		return {
			build: ''
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
		this.$nextTick(() => {
			document.title = 'Save money with our Do-It-Yourself Title 24 report service'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Doit.vue